<script setup lang="ts">
import { save, close } from "ionicons/icons";
import {
  IonLabel,
  IonItem,
  IonList,
  IonGrid,
  IonButton,
  IonLoading,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonRow,
  IonCol,
  IonInput,
  IonFooter,
} from "@ionic/vue";
import { useContextStore } from "@/stores/context";
import { onMounted, reactive } from "vue";
import { editEvent } from "@/api/events";
import { useToasters } from "@/composition/toasters";
import { timezones } from "@/views/Event/";
import { handleError } from "@/views";
import { useWindowWidth } from "@/composition/window";

const emit = defineEmits(["cancel"]);

const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const event = reactive({
  start_date: "",
  end_date: "",
  timezone_id: "",
});
const toasters = useToasters();
const state = reactive({
  loading: true,
});

const loadLocalEvent = () => {
  event.start_date = contextStore.event.start_date.slice(0, -4);
  event.end_date = contextStore.event.end_date.slice(0, -4);
  event.timezone_id = contextStore.event.timezone_id;
};

const submit = () => {
  state.loading = true;
  editEvent({ id: contextStore.event.id, ...event })
    .then(() => {
      state.loading = false;
      toasters.addSuccess("Event info saved successfuly");

      if (isMobile) {
        cancel();
      }
    })
    .catch((err) => {
      state.loading = false;
      handleError(err);
    });
};

const cancel = () => {
  emit("cancel", null);
};

onMounted(() => {
  loadLocalEvent();
  state.loading = false;
});
</script>
<template>
  <div>
    <div>
      <ion-item>
        <ion-label>
          <h1>Date and time</h1>
          <p>Set when your event starts and ends.</p>
        </ion-label>
      </ion-item>
      <ion-list>
        <ion-item>
          <ion-label position="stacked"> Start date </ion-label>
          <ion-input
            v-model="event.start_date"
            placeholder="2022-09-15T06:44:00+01:00"
            type="datetime-local"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">End date</ion-label>
          <ion-input
            v-model="event.end_date"
            placeholder="2022-09-15T06:44:00+01:00"
            type="datetime-local"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Timezone</ion-label>
          <ion-select
            placeholder="Select timezone"
            interface="popover"
            v-model="event.timezone_id"
          >
            <ion-select-option
              :value="timezone"
              v-for="timezone in timezones"
              :key="`timezone-${timezone}`"
              >{{ timezone }}</ion-select-option
            >
          </ion-select>
        </ion-item>
      </ion-list>
      <ion-button
        v-if="!isMobile"
        style="margin: 20px auto; width: 200px"
        expand="block"
        color="success"
        @click="submit()"
      >
        <ion-icon slot="start" :icon="save"></ion-icon>
        Save
      </ion-button>
    </div>
    <ion-footer v-if="isMobile">
      <div class="container">
        <section>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-button expand="block" color="light" @click="cancel()">
                  <ion-icon slot="start" :icon="close"></ion-icon>
                  Cancel
                </ion-button>
              </ion-col>
              <ion-col>
                <ion-button expand="block" color="success" @click="submit()">
                  <ion-icon slot="start" :icon="save"></ion-icon>
                  Save
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </section>
      </div>
    </ion-footer>
    <ion-loading :is-open="state.loading" message="Please wait...">
    </ion-loading>
  </div>
</template>
